import React, { useState, useEffect, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IDetailList, stockEntryService, IStockEntryFields} from "../../stockEntryService"

import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";

export const useOutputDetailsModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IStockEntryFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const getDetailLookOne = async (id: string, pattern: string) => {
        let { retData } = await stockEntryService.one(id);
        const { details, ...from } = retData
        setDetailLookForm(from);
        setDetailLookList(details as IDetailList[])   
    }
    return {
        detailLookForm,
        detailLookList,
        setDetailLookForm,
        setDetailLookList,
        getDetailLookOne
    }
})